import { getAvailablePaymentTerms } from "app/reducers/partnerSelector";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { paymentTypeShape } from "app/utils/propTypes";
import PaymentDescriptionTerms from "app/pages/Booking/Payment/PaymentDescriptionTerms/PaymentDescriptionTerms";

const PaymentDescriptionTermsContainer = props => {
	return <PaymentDescriptionTerms {...props} />;
};
const mapStateToProps = state => {
	return {
		availablePaymentTerms: getAvailablePaymentTerms(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
	};
};
PaymentDescriptionTermsContainer.propTypes = {
	availablePaymentTerms: PropTypes.arrayOf(paymentTypeShape),
	availablePaymentMethods: PropTypes.array,
};

export default connect(mapStateToProps)(PaymentDescriptionTermsContainer);
